"use client";

import { useCareerStage } from "@/hooks/useCareerStage";
import {
  CAREER_STAGE_LABELS,
  type CareerStageValue,
} from "@/lib/guestCareerStage";

// ヘッダーに出す練習タイプのバッジ。3区分を色でも見分けられるようにする。
// 表記は CAREER_STAGE_LABELS（就活 / 転職 / 高校生）に従い、ここで文字列を作り直さない。
const BADGE_COLOR_CLASS: Record<CareerStageValue, string> = {
  new_grad: "bg-success",
  mid_career: "bg-primary",
  high_school: "bg-high-school",
};

export default function CareerStageBadge() {
  const { careerStage } = useCareerStage();

  // 未設定・取得前・取得失敗はいずれも careerStage=null になる。
  // バッジは補助情報であり、判別できないまま出すより出さないほうが無害なので何も描画しない。
  if (!careerStage) return null;

  return (
    <span
      data-testid="career_stage_badge"
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-bold text-white ${BADGE_COLOR_CLASS[careerStage]}`}
    >
      {CAREER_STAGE_LABELS[careerStage]}
    </span>
  );
}
